var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form',{attrs:{"action":"/create-checkout-session","method":"POST"}},[_c('button',{attrs:{"type":"submit"}},[_vm._v("Checkout")])])])
}]

export { render, staticRenderFns }